// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"e0597980","685":"1f32f98b","739":"7e7127bc","787":"bd2e414b"}[chunkId] + ".chunk.js";
};